import React from 'react';
import {connect} from 'react-redux';
import {regions, statusOf, coordinatesOf} from '../navigation/model';
import { Switch, Case } from './Switch';

const encode = (region, status) => [region, status];
const decodeRegion = es => es[0];
const decodeStatus = es => es[1];

const makeMatch = (region, status) => v => (
    ( !region || (region === decodeRegion(v)) ) &&
    ( !status || (status === decodeStatus(v)) )
);

const Page = ({region, status, children}) => (
    <Case match = {makeMatch(region, status)}>
        {children}
    </Case>
);

const PageSelector = ({region, status, children}) => (
        <Switch value = {encode(region, status)}>
            {children}
        </Switch>
);

const ConnectedPageSelector = connect(
    state => {
        const status = statusOf(state);
        const region = coordinatesOf(state).region || regions.HOME;
        return {region, status};
    },
    dispatch => ({})
)(PageSelector);

export { PageSelector, ConnectedPageSelector, Page }



// WEBPACK FOOTER //
// ./src/view/PageSelector.js